import React, { Component, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { taskRequestRead, taskUnconformityRead } from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { getProtectedRoute } from 'helpers/routeHelper';
import Breadcrumb from 'molecules/Breadcrumb';
import CompanyFilter from 'molecules/CompanyFilter';
import { StyledTabBar, StyledTab } from './styles';
import { connect } from 'react-redux';
import routes from './routes';

import {
  ROUTE_CONFORMITY_LIST,
  ROUTE_SUPPORT_REQ_LIST
} from 'fixtures/routes';

export class TaskListRouter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      [`allow-${ROUTE_SUPPORT_REQ_LIST}`]: true,
      [`allow-${ROUTE_CONFORMITY_LIST}`]: true
    }
  }

  componentDidMount() {
    this.checkPermissions()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userLogin !== this.props.userLogin) {
      this.checkPermissions()
    }
  }

  // method for checking access permission
  checkPermissions() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        [`allow-${ROUTE_SUPPORT_REQ_LIST}`]: permissionCheck(permissions, taskRequestRead),
        [`allow-${ROUTE_CONFORMITY_LIST}`]: permissionCheck(permissions, taskUnconformityRead)
      })
    }
  }

  render() {
    const { match: { path }, history: { location: { pathname } }, viewState: { isShowTab } } = this.props
    const navList = [
      'Task',
      pathname.includes(ROUTE_SUPPORT_REQ_LIST) ?
        'Task List Support Request' :
        pathname.includes(ROUTE_CONFORMITY_LIST) ?
          'Task List Unconformity' :
          null
    ]

    return (
      <div className={'p-4'}>
        {isShowTab &&
          <Fragment>
            <Breadcrumb navList={navList}>
              <CompanyFilter />
            </Breadcrumb>
            <StyledTabBar>
              {this.state[`allow-${ROUTE_SUPPORT_REQ_LIST}`] &&
                <StyledTab to={`${path}/${ROUTE_SUPPORT_REQ_LIST}`}>Support Request</StyledTab>
              }
              {this.state[`allow-${ROUTE_CONFORMITY_LIST}`] &&
                <StyledTab to={`${path}/${ROUTE_CONFORMITY_LIST}`}>Unconformity</StyledTab>
              }
            </StyledTabBar>
          </Fragment>
        }

        <div>
          {routes.map((r, i) =>
            // mount Tasks child routes
            <Route
              key={i}
              path={`${this.props.match.url}${r.path}`}
              exact={r.exact}
              render={props => getProtectedRoute(r, props)}
            />
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userLogin: state.userLogin,
    viewState: state.viewState
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(TaskListRouter)
)
